import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Reviews() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* Left Image */}
            <div className="lg:w-[38%] relative">
              <div className="aspect-[3/4] lg:aspect-auto lg:h-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylish%20european%20person%20in%20neutral%20beige%20linen%20outfit%20standing%20against%20sunlit%20textured%20wall%20holding%20modern%20tablet%20device%20showing%20colorful%20charts%20warm%20afternoon%20glow%20natural%20relaxed%20expression%20candid%20editorial%20portrait%20lifestyle%20photography%20soft%20shadows%20clean%20aesthetic&width=700&height=900&seq=review-img-v2&orientation=portrait&nocache=true"
                  alt="OOPBUY Spreadsheet user experience"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Overlap effect */}
              <div className="hidden lg:block absolute -right-4 top-0 bottom-0 w-8 bg-foreground-950 rounded-l-2xl"></div>
            </div>

            {/* Right Content */}
            <div className="lg:w-[62%] flex flex-col justify-center px-6 py-10 md:px-12 md:py-14 lg:px-16 lg:py-20">
              <div className="text-accent-400 text-7xl md:text-8xl font-heading leading-none mb-6 select-none">
                &ldquo;
              </div>
              <blockquote className="text-base md:text-lg lg:text-xl text-background-50/90 leading-relaxed mb-8 font-light">
                {t('reviews.text')}
              </blockquote>
              <div className="mb-8">
                <p className="text-base font-semibold text-background-50">{t('reviews.name')}</p>
                <p className="text-sm text-background-50/50 mt-0.5">{t('reviews.role')}</p>
              </div>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-foreground-950 bg-accent-400 rounded-full hover:bg-accent-300 transition-colors whitespace-nowrap cursor-pointer w-fit"
              >
                {t('reviews.cta')}
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}